import React from 'react';
import { Box, Typography, Grid } from '@mui/material';

const Text: React.FC = () => {
    return (
        <Box padding={{ xs: 4, md: 10 }} sx={{ backgroundColor: '#2d2d2d', color: '#ffffff' }}>
            <Grid container sx={{ maxWidth: '130ch', margin: '0 auto' }}>
                <Grid item xs={12} md={6} sx={{ paddingLeft: { xs: 2, md: 4 }, paddingRight: { xs: 2, md: 4 }, margin: '0 auto' }}>
                    <Typography variant="h6" gutterBottom sx={{ fontSize: { xs: '0.9rem', md: '1rem' }, fontWeight: "bold" }}>
                        Crypto has the power to change the world
                    </Typography>
                    {[
                        "The crypto market suffers from both misconceptions and bias, much like the internet shopping and online payment was met with skepticism in the late 90’s.",
                        "The crypto world is still in its early stage and has been growing immensely the last 7 years.",
                        "Today, one out of ten internet accounts have an account linked to the crypto world. The trading value of crypto is $90 trillion yearly and is estimated to grow to $200 trillion by year 2030.",
                        "This is all great but what is the actual use of the crypto market to the real world?",
                        "There is another market that has a long track record and public acceptability – the stock market.",
                        "However, there is a small part (<1%) of the stock market that is both dysfunctional and in desperate need to attract trade and money - the SMEs!"
                    ].map((text, index) => (
                        <Typography key={index} paragraph sx={{ fontSize: { xs: '0.9rem', md: '1rem' }, maxWidth: '200ch' }}>
                            {text}
                        </Typography>
                    ))}
                </Grid>
                <Grid item xs={12} md={6} sx={{ paddingLeft: { xs: 2, md: 4 }, paddingRight: { xs: 2, md: 4 }, margin: '0 auto' }}>
                    {[
                        "SME (Small and Medium sized Enterprises) are vital for the prosperity, stand for most of all innovations and employ 70% of the world population.",
                        "However, they are in desperate need of funding to stay alive.",
                        "Listed SME only have a fraction (0.1%) of the trade value compared to the crypto world and there are over 45,000 listed SMEs globally with a total market value of $2,000 billion.",
                        "What if you could bring together the capital market for SMEs with the world of crypto?",
                        "Crypto traders seek highly speculative and volatile instruments, and the SMEs need the trading volumes. It’s a perfect match!",
                        "Imagine, it would only take 5% of the crypto trade to fulfill the funding need of all SMEs globally.",
                        "As soon as the public starts to accept and notice that crypto can add value to the real world, the trust will be gained.",
                        "Finally, the world of crypto will become as well accepted as the internet shopping is today."
                    ].map((text, index) => (
                        <Typography key={index} paragraph sx={{ fontSize: { xs: '0.9rem', md: '1rem' }, maxWidth: '200ch' }}>
                            {text}
                        </Typography>
                    ))}
                </Grid>
            </Grid>
        </Box>
    );
};

export default Text;
